export function sanitizeColor(hex){
    if(/^#[0-9A-F]{6}$/i.test(hex)){
        return hex;
    }
    return '';
}